import { render, staticRenderFns } from "./ProductServiceNavCard.vue?vue&type=template&id=4fe3913b&scoped=true"
import script from "./ProductServiceNavCard.vue?vue&type=script&lang=js"
export * from "./ProductServiceNavCard.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceNavCard.vue?vue&type=style&index=0&id=4fe3913b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3913b",
  null
  
)

export default component.exports